import Tournament from '~/components/Tournament/Tournament';

const EditTournament = () => {
  return <Tournament isEdit />;
};

export default EditTournament;
